module.exports = __webpack_public_path__ + "static/media/dominosLogo.71ffdef4.png";